import { memo, useCallback } from "react";
import classNames from "classnames";

import classes from "./Toggle.module.less";

interface ToggleProps {
  className?: string;
  name?: string;
  checked?: boolean;
  invalid?: boolean;
  disabled?: boolean;
  onCheck?: (newVal: boolean) => void;
}

const Toggle = ({ className, name, checked, disabled, onCheck }: ToggleProps) => {
  const onClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      if (!disabled && onCheck) {
        onCheck(!checked);
      }
    },
    [disabled, checked, onCheck]
  );

  const cls = classNames(classes.root, checked && classes.checked, disabled && classes.disabled, className);
  return (
    <div className={cls} onClick={onClick}>
      {name && <input type="checkbox" hidden={true} name={name} checked={checked} />}
      <div className={classes.knob} />
    </div>
  );
};

export default memo(Toggle);
